import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import moment from "moment";

import styles from "../styles/list.module.css";
import commonStyles from "../../../lib/common/common.module.css";
import { APP_ROUTES, LOCAL_CONSTANTS } from "../../../lib/constants";
import { OrderTypes, UserTypes } from "../../../interfaces";
import { Layout, Pagination } from "../../../ui";
import { list, partnerWebsitesList } from "../api";
import Select from "react-select";
import { toast } from "react-toastify";
import ModifyESim from "./modifyESim";
import { exportOrdersList, sendManualESIMEmail } from "../../deeplink/api";
import EmailModal from "../../deeplink/components/EmailModal";
import { Button, Modal } from "react-bootstrap";
import usageModalStyles from "../../partners/styles/style.module.css";

const JOYTEL_USAGE_API =
  "https://api-cb.commbitz.com/esim/joytel-esim-usage-enquiry";

interface UsageData {
  effectiveTime: string;
  expiryTime: string;
  totalUsage: number;
  totalUsageFormatted?: string;
  dailyUsage: Array<{ date: string; usage: string; region?: { country: string } }>;
  summary?: {
    totalDays: number;
    averageDailyUsage: string;
    highestUsageDay: string;
    lowestUsageDay: string;
  };
}

interface ProfileData {
  eid?: string;
  device?: string;
  clientIp?: string;
  pin1?: string;
  pin2?: string;
  puk1?: string;
  puk2?: string;
  imei?: string;
  mcc?: string;
  cfCode?: string;
  apnExplain?: string;
  state?: string;
  profileType?: string;
}

export const ORDER_STATUS: Record<string, number> = {
  PENDING: 1,
  SUCCESS: 2,
  FAILED: 3
};
const Orders = () => {
  const navigate = useNavigate();
  const roles = window.localStorage.getItem("admin_roles");
  const isRole26 = Number(roles) === 26;
  const FIXED_PARTNER_WEBSITE_ID = "667000f74e37cd362882386e";

  const [pagination, setPagination] = useState({
    skip: 0,
    limit: LOCAL_CONSTANTS.limitCount,
  });
  const [exportLoading, setExportLoading] = useState<boolean>(false);
  const [search, setSearch] = useState<string>("");
  const [partenList, setPartenList] = useState<any>([]);
  const [partenListVal, setPartenListVal] = useState<any>("");
  const [partnerWebsiteId, setPartnerWebsiteId] = useState<any>(
    isRole26 ? FIXED_PARTNER_WEBSITE_ID : ""
  );
  const [order, setSortOrder] = useState<number>();
  const [sortBy, setSortColumn] = useState<string>("");
  const [payments, setOrdersList] = useState<{
    list: OrderTypes.Payment[];
    count: number;
  }>({
    list: [],
    count: 0,
  });
  const [loading, setLoading] = useState<boolean>(true);
  const [filterOrderRangeStartDate, setFilterOrderRangeStartDate] = useState<string>("");
  const [filterOrderRangeEndDate, setFilterOrderRangeEndDate] = useState<string>("");
  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState<any>(null);
  const [showUsageModal, setShowUsageModal] = useState(false);
  const [usageCoupon, setUsageCoupon] = useState<string | null>(null);
  const [usageLoading, setUsageLoading] = useState(false);
  const [usageData, setUsageData] = useState<UsageData | null>(null);
  const [profileData, setProfileData] = useState<ProfileData | null>(null);
const fetchUsageData = async (coupon: string) => {
    setUsageLoading(true);
    setUsageData(null);
    setProfileData(null);
    try {
      const res = await fetch(
        `${JOYTEL_USAGE_API}?coupon=${encodeURIComponent(coupon)}`
      );
      const json = await res.json();
      const inner = json?.data?.data;
      const profileInfo = json?.data?.profileInfo;
      if (inner) setUsageData(inner);
      if (profileInfo) {
        setProfileData({
          eid: profileInfo.eid ?? "",
          device: profileInfo.device ?? "",
          clientIp: profileInfo.clientIp ?? "",
          pin1: profileInfo.pin1 ?? "",
          pin2: profileInfo.pin2 ?? "",
          puk1: profileInfo.puk1 ?? "",
          puk2: profileInfo.puk2 ?? "",
          imei: profileInfo.imei ?? "",
          mcc: profileInfo.mcc ?? "",
          cfCode: profileInfo.cfCode ?? "",
          apnExplain: profileInfo.apnExplain ?? "",
          state: profileInfo.state,
          profileType: profileInfo.profileType,
        });
      }
    } catch {
      setUsageData(null);
      setProfileData(null);
    } finally {
      setUsageLoading(false);
    }
  };

  const openUsageModal = (coupon: string) => {
    setUsageCoupon(coupon);
    setShowUsageModal(true);
    fetchUsageData(coupon);
  };

  const closeUsageModal = () => {
    setShowUsageModal(false);
    setUsageCoupon(null);
    setUsageData(null);
    setProfileData(null);
  };

  const handleEmailClick = (user: any,bundle:any,obj:any) => {
    const formData = user;
    const fullName = formData?.fullName || "";
    const email = formData?.email || "";
    const country = bundle?.name||"" ;
    const data=bundle?.dataAmount/1000
    const duration=bundle?.duration

    // Set the selected user data with all required fields
    setSelectedUser({
      couponId:obj._id,
      firstName: fullName,
     
      email,
      countryName: country,
      qrImageUrl: "",
      iccid: "",
      dataAmount:data,
      duration: duration,
      planName: ""
    });
    setIsEmailModalOpen(true);
  };

  const handleEmailSubmit = async (formData: {
    firstName: string;
    email: string;
    qrImageUrl: string;
    iccid: string;
    dataAmount: number;
    duration: number;
    planName: string;
    countryName: string;
    couponId: string;
   
    
  }) => {
    try {
      //@ts-ignore
      formData.orderId=formData?.couponId
      await sendManualESIMEmail(formData);
      toast.success("eSIM email sent successfully!");
      setIsEmailModalOpen(false);
listOrders()    } catch (error) {
      console.error('Error sending email:', error);
      toast.error("Failed to send eSIM email. Please try again.");
    }
  };
  
  const [activeTab, setActiveTab] = useState<Number>(1);
  const [selectedStatus, setSelectedStatus] = useState<any>(null);

  const listOrders = () => {
    const query: any = {
      page: 1 + pagination.skip,
      limit: pagination.limit,
      search,
      order,
      // sortBy,
    };
    // For role 26, always apply the fixed partnerWebsiteId filter
    if (isRole26) {
      query.partnerWebsiteId = FIXED_PARTNER_WEBSITE_ID;
    } else if (partnerWebsiteId) {
      query.partnerWebsiteId = partnerWebsiteId;
    }
    if (selectedStatus) {
      query.orderStatus = selectedStatus.value; // Filter by selected status
    }
    if (filterOrderRangeStartDate) {
      query.filterOrderRangeStartDate = filterOrderRangeStartDate;
    }
    if (filterOrderRangeEndDate) {
      query.filterOrderRangeEndDate = filterOrderRangeEndDate;
    }
    
    console.log("API query:", query); 
    list(query).then(({ data }) => {
      setOrdersList({ list: data?.orders, count: data?.count });
      console.log(data.orders)
      setLoading(false);
    });
  };

  useEffect(() => {
    partnerWebsitesList()
      .then((res) => {
        setPartenList(res?.data);
      })
      .catch((error) => {
        toast.error(error?.data?.message || "Something went wrong!");
      });
  }, []); // Empty dependency array means this runs once on mount

  // Search debounce effect
  useEffect(() => {
    const debounceSearch = setTimeout(() => {
      if (search !== null) { // Only call when search state changes intentionally
        listOrders();
      }
    }, 500);

    return () => {
      clearTimeout(debounceSearch);
    };
  }, [search]);
  const partenListOptions = partenList.map((parten: any) => ({
    value: parten._id,
    label: parten?.websiteUrl || "",
  })).filter((option: any) => option.label); // Filter out any options with empty labels

  // Initialize and enforce partnerWebsiteId for role 26
  useEffect(() => {
    if (isRole26) {
      // Always set to fixed value for role 26, cannot be changed
      if (partnerWebsiteId !== FIXED_PARTNER_WEBSITE_ID) {
        setPartnerWebsiteId(FIXED_PARTNER_WEBSITE_ID);
      }
    }
  }, [isRole26, partnerWebsiteId]);

  useEffect(() => {
    setLoading(true);
    listOrders();
  }, [pagination.skip, partnerWebsiteId,selectedStatus,filterOrderRangeStartDate, filterOrderRangeEndDate]);

  const handleSort = (column: string) => {
    setSortColumn(column);
    setSortOrder(
      order === LOCAL_CONSTANTS.descKey
        ? LOCAL_CONSTANTS.ascKey
        : LOCAL_CONSTANTS.descKey
    );
    const query = {
      ...pagination,
      search,
      order:
        order === LOCAL_CONSTANTS.descKey
          ? LOCAL_CONSTANTS.ascKey
          : LOCAL_CONSTANTS.descKey,
      sortBy: column,
    };
    list(query).then(({ data }) => {
      setOrdersList({ list: data?.orders, count: data?.count });
      setLoading(false);
    });
  };
  const renderSortIcon = (column: string) => {
    if (sortBy === column) {
      return order === LOCAL_CONSTANTS.descKey ? " ▼" : " ▲";
    }
    return null;
  };
  const handleCopyUrl = async (url: string, urlType: string = "URL") => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success(`${urlType} copied to clipboard!`);
    } catch (err) {
      // Fallback for older browsers
      const textArea = document.createElement("textarea");
      textArea.value = url;
      textArea.style.position = "fixed";
      textArea.style.left = "-999999px";
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand("copy");
        toast.success(`${urlType} copied to clipboard!`);
      } catch (error) {
        toast.error("Failed to copy URL");
      }
      document.body.removeChild(textArea);
    }
  };
  const orderStatusOptions = Object.keys(ORDER_STATUS).map((key) => ({
    value: ORDER_STATUS[key as keyof typeof ORDER_STATUS],  // Ensure safe access
    label: key.charAt(0) + key.slice(1).toLowerCase(),  // Converts to label: "Pending", "Success", "Failed"
  }));
  const handleStatusChange = (selectedOption: any) => {
    setSelectedStatus(selectedOption);
  };
  const handleResetFilters = () => {
    setSearch("null");
    // Don't reset partnerWebsiteId for role 26
    if (!isRole26) {
      setPartnerWebsiteId("");
      setPartenListVal("");
    }
    setFilterOrderRangeStartDate("");
    setFilterOrderRangeEndDate("");
    setSelectedStatus(null);
    setPagination({
      skip: 0,
      limit: LOCAL_CONSTANTS.limitCount,
    });
    setTimeout(() => {
      setSearch("");
    }, 0);
  };
  const handleExportCSV = async () => {
    try {
      setExportLoading(true);

      const query: any = {
        page: 1 + pagination.skip,
        limit: pagination.limit,
        search,
        order,
      };
      
      // For role 26, always apply the fixed partnerWebsiteId filter
      if (isRole26) {
        query.partnerWebsiteId = FIXED_PARTNER_WEBSITE_ID;
      } else if (partnerWebsiteId) {
        query.partnerWebsiteId = partnerWebsiteId;
      }
      
      const response = await exportOrdersList(query);
      
      // Log raw response to see exact structure
      console.log('Raw response:', response);
      console.log('Response data:', response.data);
      
      // Get CSV content from response
      let csvContent = '';
      if (typeof response === 'string') {
        csvContent = response;
      } else if (typeof response.data === 'string') {
        csvContent = response.data;
      } else {
        throw new Error('Unexpected response format');
      }

      // Verify we have content
      if (!csvContent) {
        throw new Error('No CSV content received');
      }

      console.log('Final CSV content:', csvContent);
      
      // Create blob with the CSV string
      const blob = new Blob([csvContent], { 
        type: 'text/csv;charset=utf-8'
      });
      
      // Download file
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      const fileName = `orders-list-${moment().format('YYYY-MM-DD')}.csv`;
      
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      
      toast.success('CSV exported successfully');
    } catch (err: any) {
      console.error('Export error:', err);
      if (err.response) {
        console.log('Error response:', err.response);
        console.log('Error response data:', err.response.data);
      }
      toast.error('Failed to export CSV');
    } finally {
      setExportLoading(false);
    }
  };

  return (
    <Layout title="Orders">
      <div className={commonStyles.tableData}>
        <div className={styles.mainTabbing}>
          <div className="leftTabbing">
            <div className={styles.topCms}>
              <ul>
                <li
                  className={activeTab === 1 ? styles.active : ""}
                  onClick={() => {
                    setSearch("");
                    setActiveTab(1);
                  }}
                >
                  <p>Online Orders</p>
                </li>
                <li
                  className={activeTab === 2 ? styles.active : ""}
                  onClick={() => {
                    setSearch("");
                    setActiveTab(2);
                  }}
                >
                  <p>Manual Orders</p>
                </li>
              </ul>
              <div>
              <button 
          onClick={handleExportCSV}
          disabled={exportLoading}
          className={`${styles.loyalityPointBtn} ${exportLoading ? styles.loading : ''}`}
        >
          {exportLoading ? 'Exporting...' : 'Export CSV'}
        </button>
              </div>
            </div>
          </div>
        </div>
        <div className={commonStyles.topFilter}>
          {activeTab == 1 && !isRole26 && (
            <>
              <div className="">
                <Select
                  options={[
                    { value: "", label: "Select option" },
                    ...partenListOptions,
                  ]}
                  onChange={(data: any) => {
                    setPartnerWebsiteId(data?.value || "");
                    setPartenListVal(data?.value || "");
                  }}
                  value={partenListOptions.find(
                    (option: any) => option.value === partnerWebsiteId
                  ) || (partnerWebsiteId === "" ? { value: "", label: "Select option" } : null)}
                  placeholder="Select Partner Website"
                  isClearable={true}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    menu: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                />
              </div>
              
            </>
          )}
            <div className="">
            <Select
              options={orderStatusOptions}
              value={selectedStatus}
              onChange={handleStatusChange}
              placeholder="Select Order Status"
            />
          </div>
          <div className={styles.date_calender}>
          <input
          className="text-white "
            type="search"
            placeholder="Search by name or email"
            value={search || ""}
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          />
          </div>
          <div className={styles.date_calender}>
      <input
        type="date"
        value={filterOrderRangeStartDate}
        onChange={(e) => setFilterOrderRangeStartDate(e.target.value)}
        placeholder="Start Date"
      />
    </div>
    <div className={styles.date_calender}>
      <input
        type="date"
        value={filterOrderRangeEndDate}
        onChange={(e) => setFilterOrderRangeEndDate(e.target.value)}
        placeholder="End Date"
      />
    </div>
    <button
                onClick={() => navigate(APP_ROUTES.LOYALITY_POINTS_SETTINGS)}
                className={styles.loyalityPointBtn}
              >
                Edit Loyality Point
              </button>
              {activeTab == 2 && (
            <button
              onClick={() => navigate(APP_ROUTES.INDIVIDUAL_ADMIN)}
              className={styles.loyalityPointBtn}
            >
              Add Individual Order
            </button>
          )}
          <button
            onClick={handleResetFilters}
            className={styles.loyalityPointBtn}
          >
            Reset 
          </button>
         
        </div>
        <div className={styles.scrollTable}>
          <table>
            <thead>
              <tr>
                {LOCAL_CONSTANTS.paymentsTableHeaders?.map(
                  (header: UserTypes.TableHeader) => (
                    <th
                      className={`${
                        ["user.fullName", "bundle.name", "price"].includes(
                          header?.value
                        )
                          ? "cursor-pointer"
                          : ""
                      }`}
                      onClick={() => {
                        if (
                          ["user.fullName", "bundle.name", "price"].includes(
                            header?.value
                          )
                        ) {
                          handleSort(header?.value);
                        }
                      }}
                      key={header?.value}
                    >
                      {header?.label}
                      {sortBy === header?.value &&
                        ["user.fullName", "bundle.name", "price"].includes(
                          header?.value
                        ) &&
                        renderSortIcon(header?.value)}
                    </th>
                  )
                )}
              </tr>
            </thead>
            <tbody>
              {loading && (
                <tr>
                  <td colSpan={LOCAL_CONSTANTS.paymentsTableHeaders?.length || 25} align="center">
                    {LOCAL_CONSTANTS.loading}
                  </td>
                </tr>
              )}
              {!loading && payments.list.length === 0 && (
                <tr>
                  <td colSpan={LOCAL_CONSTANTS.paymentsTableHeaders?.length || 25} align="center">
                    No Order Found
                  </td>
                </tr>
              )}
              {!loading &&
                payments?.list?.map((item: any) => (
                  <tr key={item._id}>
                    <td>{`${item.user?.fullName || LOCAL_CONSTANTS.na} ${
                      item?.partnerWebsiteName
                        ? "( from " +
                          (item?.partnerWebsiteName).split(".")[0] +
                          " )"
                        : ""
                    }`}</td>
                    <td>{`${item.user?.email || LOCAL_CONSTANTS.na}`}</td>
                    <td>{!item.user?.countryCode ? LOCAL_CONSTANTS.na : item.user?.countryCode + " " + item.user?.phoneNumber}</td>
                    <td>{item.bundle?.name||"N/A"}</td>
                    <td>
                      {moment.utc(item.createdAt).format("DD/MM/YYYY")}
                    </td>
                    <td>
                      {
                        LOCAL_CONSTANTS.paymentOrderStatus?.find(
                          (elt: OrderTypes.StatusEnums) =>
                            elt.value === item.orderStatus
                        )?.label
                      }
                    </td>
                    <td>
                      {
                        LOCAL_CONSTANTS.paymentOrderStatus?.find(  
                          (elt: OrderTypes.StatusEnums) =>
                            elt.value === item.paymentStatus
                        )?.label
                      }
                    </td>
                    <td>{item.priceCurrency ||"N/A"}</td>
                    <td>{item.price.toFixed(2)||"N/A"}</td>
                    <td>{item.quantity||"N/A"}</td>
                    <td>{item?.bundle?.dataAmount == '-1' ? "Unlimited":item?.bundle?.dataAmount/1000+" GB"||"N/A"}</td>
                    <td>{item?.couponCode ||"N/A"}</td>
                    <td>{item?.discountPrice ||"N/A"}</td>
                    <td>{item?.bundle?.duration||"N/A"}{item?.bundle?.duration && item?.bundle?.duration > 1 ? " Days" : " Day"}</td>
                    <td>{item?.orderPlacementLocation?.country ||"N/A"}</td>
                    <td className={styles.urlCell} title={item.url}>
                      {item.url ? (
                        <div className={styles.urlContainer}>
                          <a href={item.url} target="_blank" rel="noopener noreferrer">
                            {item.url}
                          </a>
                          <button
                            className={styles.copyButton}
                            onClick={() => handleCopyUrl(item.url, "URL")}
                            title="Copy URL"
                          >
                            📋
                          </button>
                        </div>
                      ) : (
                        "N/A"
                      )}
                    </td>
                    <td className={styles.urlCell} title={item?.homePageUrl}>
                      {item?.homePageUrl ? (
                        <div className={styles.urlContainer}>
                          <a href={item.homePageUrl} target="_blank" rel="noopener noreferrer">
                            {item.homePageUrl}
                          </a>
                          <button
                            className={styles.copyButton}
                            onClick={() => handleCopyUrl(item.homePageUrl, "Home Page URL")}
                            title="Copy Home Page URL"
                          >
                            📋
                          </button>
                        </div>
                      ) : (
                        "N/A"
                      )}
                    </td>
                    {/* {item?.documents &&  */}
                    <td>{item?.activationDetails?.convertToEsim?"Convert To Esim":item?.activationDetails?.simTypeLabel||item?.activationDetails?.simTypeLabel||"N/A"}</td>
                    <td>{item?.activationDetails?.simNumber||"N/A"}</td>
                    <td>{item?.activationDetails?.imei||"N/A"}</td>
                    <td>{item?.activationDetails?.eid||"N/A"}</td>
                    <td>{item?.activationDetails?.physicalSimAddress||"N/A"}</td>
                    <td>{item?.esimDetails?.length ? item.esimDetails.map((e: any) => e?.iccid).filter(Boolean).join(", ") : "N/A"}</td>
                    <td>{item?.esimDetails?.length ? item.esimDetails.map((e: any) => e?.smdpCode).filter(Boolean).join(", ") : "N/A"}</td>
                    <td>{item?.esimDetails?.length ? item.esimDetails.map((e: any) => e?.coupon).filter(Boolean).join(", ") : "N/A"}</td>
                    <td className="d-flex gap-2">
                     {/* {partnerWebsiteId=== "667000f74e37cd362882386e" && <ModifyESim />}  */}
                      <button
                        className={styles.loyalityPointBtn}
                        onClick={() => navigate(`/document/${item._id}`)}
                      >
                        View
                      </button>
                      <button
                        className={styles.loyalityPointBtn}
                        disabled={!item?.esimDetails?.length}
                        onClick={() => {
                          const last = item.esimDetails[item.esimDetails.length - 1];
                          const coupon = last?.coupon;
                          if (coupon) openUsageModal(coupon);
                        }}
                      >
                        View Usage
                      </button>
                    </td>
                    <td>
                      {
                        <button 
                        className={styles.loyalityPointBtn}
                        disabled={!(!item?.adminManualEsimQrEmailSent&&item.orderStatus===1)}
                        onClick={() => handleEmailClick(item?.user,item?.bundle,item)}
                        >{item.adminManualEsimQrEmailSent?"Email Sent":"Send Email"}</button>
                      }
                      
                    </td>
                    {/* } */}
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
        <Pagination
          paginationState={pagination}
          setPaginationState={setPagination}
          count={payments.count}
        />
      </div>
      {selectedUser && (
        <EmailModal
          isOpen={isEmailModalOpen}
          onClose={() => {
            setIsEmailModalOpen(false);
            setSelectedUser(null);
          }}
          onSubmit={handleEmailSubmit}
          initialData={selectedUser}
        />
      )}
      <Modal
        show={showUsageModal}
        onHide={closeUsageModal}
        size="xl"
        centered
        className={usageModalStyles.usageModal}
      >
        <Modal.Header closeButton>
          <Modal.Title>Data Usage Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {usageLoading ? (
            <div className="text-center py-4">Loading...</div>
          ) : !usageCoupon ? (
            <div className="text-center py-4">No coupon available</div>
          ) : usageData ? (
            <div className={usageModalStyles.usageContent}>
              <div className={usageModalStyles.usageSummaryCard}>
                <div className={usageModalStyles.summaryItem}>
                  <h4>Total Usage</h4>
                  <p>{usageData.totalUsageFormatted ?? usageData.totalUsage}</p>
                </div>
                <div className={usageModalStyles.summaryItem}>
                  <h4>Validity Period</h4>
                  <p>From: {usageData.effectiveTime}</p>
                  <p>To: {usageData.expiryTime}</p>
                </div>
              </div>
              {usageData.dailyUsage?.length > 0 && (
                <>
                  <div className={usageModalStyles.usageStats}>
                    <h4>Usage Statistics</h4>
                    <div className={usageModalStyles.statsGrid}>
                      <div className={usageModalStyles.statItem}>
                        <span>Total Days</span>
                        <strong>{usageData.summary?.totalDays ?? 0}</strong>
                      </div>
                      <div className={usageModalStyles.statItem}>
                        <span>Average Daily</span>
                        <strong>
                          {usageData.summary?.averageDailyUsage ?? "0 MB"}
                        </strong>
                      </div>
                      <div className={usageModalStyles.statItem}>
                        <span>Highest Usage</span>
                        <strong>
                          {usageData.summary?.highestUsageDay ?? "0 MB"}
                        </strong>
                      </div>
                      <div className={usageModalStyles.statItem}>
                        <span>Lowest Usage</span>
                        <strong>
                          {usageData.summary?.lowestUsageDay ?? "0 MB"}
                        </strong>
                      </div>
                    </div>
                  </div>

                  <div className={usageModalStyles.dailyUsageSection}>
                    <h4>Daily Usage Breakdown</h4>
                    <div className={usageModalStyles.usageTable}>
                      <table className="table">
                        <thead>
                          <tr>
                            <th>Date</th>
                            <th>Usage</th>
                            <th>Region</th>
                          </tr>
                        </thead>
                        <tbody>
                          {usageData.dailyUsage.map((usage, index) => (
                            <tr key={index}>
                              <td>{usage.date}</td>
                              <td>{usage.usage}</td>
                              <td>
                                {usage.region?.country ?? LOCAL_CONSTANTS.na}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </>
              )}

              {profileData && (
                <div className={`mt-5 ${usageModalStyles.profileDataSection}`}>
                  <h4>Profile Information</h4>
                  <div className={usageModalStyles.profileGrid}>
                    <div className={usageModalStyles.profileItem}>
                      <div className={usageModalStyles.profileLabel}>EID:</div>
                      <div className={usageModalStyles.profileValue}>
                        {profileData.eid ?? ""}
                      </div>
                    </div>
                    <div className={usageModalStyles.profileItem}>
                      <div className={usageModalStyles.profileLabel}>Device:</div>
                      <div className={usageModalStyles.profileValue}>
                        {profileData.device ?? ""}
                      </div>
                    </div>
                    <div className={usageModalStyles.profileItem}>
                      <div className={usageModalStyles.profileLabel}>Client IP:</div>
                      <div className={usageModalStyles.profileValue}>
                        {profileData.clientIp ?? ""}
                      </div>
                    </div>
                    <div className={usageModalStyles.profileItem}>
                      <div className={usageModalStyles.profileLabel}>PIN1:</div>
                      <div className={usageModalStyles.profileValue}>
                        {profileData.pin1 ?? ""}
                      </div>
                    </div>
                    <div className={usageModalStyles.profileItem}>
                      <div className={usageModalStyles.profileLabel}>PIN2:</div>
                      <div className={usageModalStyles.profileValue}>
                        {profileData.pin2 ?? ""}
                      </div>
                    </div>
                    <div className={usageModalStyles.profileItem}>
                      <div className={usageModalStyles.profileLabel}>PUK1:</div>
                      <div className={usageModalStyles.profileValue}>
                        {profileData.puk1 ?? ""}
                      </div>
                    </div>
                    <div className={usageModalStyles.profileItem}>
                      <div className={usageModalStyles.profileLabel}>PUK2:</div>
                      <div className={usageModalStyles.profileValue}>
                        {profileData.puk2 ?? ""}
                      </div>
                    </div>
                    <div className={usageModalStyles.profileItem}>
                      <div className={usageModalStyles.profileLabel}>IMEI:</div>
                      <div className={usageModalStyles.profileValue}>
                        {profileData.imei ?? ""}
                      </div>
                    </div>
                    <div className={usageModalStyles.profileItem}>
                      <div className={usageModalStyles.profileLabel}>MCC:</div>
                      <div className={usageModalStyles.profileValue}>
                        {profileData.mcc ?? ""}
                      </div>
                    </div>
                    <div className={usageModalStyles.profileItem}>
                      <div className={usageModalStyles.profileLabel}>CF Code:</div>
                      <div className={usageModalStyles.profileValue}>
                        {profileData.cfCode || "N/A"}
                      </div>
                    </div>
                    <div className={usageModalStyles.profileItem}>
                      <div className={usageModalStyles.profileLabel}>APN:</div>
                      <div className={usageModalStyles.profileValue}>
                        {profileData.apnExplain ?? ""}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div className="text-center py-4">
              No usage data available
            </div>
          )}
        </Modal.Body>
      </Modal>
    </Layout>
  );
};

export default Orders;
